// packages/app/src/scaffolder/ApiGatewayPathPicker.tsx
//
// Custom field extension for the ROME API Gateway path.
// Field is optional (blank = skip the Kong route entirely — see
// templates/create-rome/service-skeleton/service.tf.njk's {% if apiGateway %}),
// but whenever a value IS entered it must start with "/". The template.yaml
// schema's `pattern` already blocks a bad value on submit, but its
// auto-generated AJV error ("must match pattern ...") is unreadable — this
// component shows a plain-English message instead.

import { useState } from 'react';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';

const PATTERN = /^(\/.*)?$/;

function validate(path: string): string | null {
  if (!path) return null; // blank is allowed — skips the Kong route
  if (!PATTERN.test(path)) {
    return 'Path should start with a forward slash, e.g. /api/path';
  }
  return null;
}

export const ApiGatewayPathPickerComponent = ({
  onChange,
  rawErrors,
  required,
  formData,
  schema,
}: FieldExtensionComponentProps<string>) => {
  const [touched, setTouched] = useState(false);

  const dynamicError = touched ? validate(formData ?? '') : null;
  const hasError = (rawErrors?.length ?? 0) > 0 || !!dynamicError;

  const helperText = dynamicError
    ?? (hasError ? 'Path should start with a forward slash, e.g. /api/path' : null)
    ?? 'API Gateway path or route. Leave blank to skip. Example: /api/path';

  return (
    <FormControl required={required} error={hasError} fullWidth>
      <TextField
        label={schema?.title ?? 'API Gateway'}
        value={formData ?? ''}
        required={required}
        error={hasError}
        helperText={helperText}
        inputProps={{ spellCheck: false }}
        onChange={e => {
          setTouched(true);
          onChange(e.target.value);
        }}
        onBlur={() => setTouched(true)}
      />
    </FormControl>
  );
};
